import { MapTo } from '@adobe/aem-react-editable-components';
import NaturalDisasterBulletinPushdown, { NaturalDisasterBulletinPushdownEditConfig } from './NaturalDisasterBulletinPushdown';

export default MapTo('cob-corp-acquisition/components/creditonebank/natural-disaster-pushdown')(NaturalDisasterBulletinPushdown, NaturalDisasterBulletinPushdownEditConfig);